import React from 'react';
import { useHistory } from 'react-router';

import submitDecor1 from '../../common/images/dashboard/carousel/submitDecor1.png';
import submitDecor2 from '../../common/images/dashboard/carousel/submitDecor2.png';
import submitDecor3 from '../../common/images/dashboard/carousel/submitDecor3.png';
import submitProject from '../../common/images/dashboard/carousel/submitProject.png';
import styles from './ProjectCarouselSlide.module.css';

export interface ProjectCarouselSlideProps {
  mobileView: boolean;
  currentSlide: number;
}

export const ProjectCarouselSlide: React.FC<ProjectCarouselSlideProps> =
  props => {
    const history = useHistory();
    const goToProjSub = () => {
      history.push('/platform/projectSubmission');
    };

    return (
      <div
        className={styles.carouselBanner + ' w-full'}
        style={
          1 === props.currentSlide ? { display: 'block' } : { display: 'none' }
        }
      >
        <div
          className={
            styles.carouselContainer +
            ' w-full h-full flex xl:justify-between justify-center flex-wrap box-border lg:p-12 lg:py-10 xl:py-12 sm:p-16 p-10 relative'
          }
          style={{
            background: '#000000',
            borderRadius: 16,
          }}
        >
          <div
            className={
              ' lg:w-1/2 w-full flex flex-col xl:gap-4 sm:gap-5 gap-6 items-center lg:items-start box-border z-10 lg:text-left text-center'
            }
          >
            <div
              className={
                styles.collectionName +
                ' text-5xl xl:text-6xl mt-2 lg:mt-3 font-extrabold'
              }
            >
              Submit Project
            </div>
            {!props.mobileView ? (
              <img
                className="w-5/6 rounded-lg"
                src={submitProject}
                alt="submitProject"
              />
            ) : null}
            <div
              className={
                'w-5/6 md:text-base sm:text-sm text-sm xl:pr-14 font-bold mb-0'
              }
            >
              Project Submissions are Open!
              <br />
              <br />
              When you submit a project our panel reviews it and the successful
              projects will be put into the Showcase.
            </div>
            {!props.mobileView ? (
              <div className="w-full mt-auto flex items-center gap-2 box-border">
                <div
                  aria-hidden
                  className={
                    styles.navButton +
                    ' w-full lg:w-5/6 h-10 lg:h-12 text-xs sm:text-sm	font-semibold	flex justify-center items-center cursor-pointer'
                  }
                  onClick={() => goToProjSub()}
                >
                  Submit Your Project
                </div>
              </div>
            ) : null}
          </div>
          <div
            className="lg:w-1/2 w-full z-10 flex flex-col justify-center lg:items-end items-center xl:gap-12 lg:gap-8 gap-4
           xl:text-xl md:text-base sm:text-sm text-sm font-bold text-start"
          >
            <div className="w-full md:w-11/12 lg:w-full flex items-center gap-6">
              <img
                className={styles.submitDecor1}
                src={submitDecor1}
                alt="submitDecor1"
              />
              <div className="-ml-2">
                Have your project viewed by Hollywood professionals
              </div>
            </div>
            <div className="w-full md:w-11/12 lg:w-full flex items-center gap-6 mb-3">
              <img
                className={styles.submitDecor2 + ' ml-1'}
                src={submitDecor2}
                alt="submitDecor2"
              />
              <div className="xl:-ml-0 -ml-1">
                Present your project in the Mogul Showcase
              </div>
            </div>
            <div className="w-full md:w-11/12 lg:w-full flex items-center gap-6">
              <img
                className={styles.submitDecor3 + ' ml-1'}
                src={submitDecor3}
                alt="submitDecor3"
              />
              <div className="xl:-ml-1 -ml-1">
                Create project-based Digital Collectibles with Mogul Productions
              </div>
            </div>
            {props.mobileView ? (
              <div className="w-full mt-auto flex items-center gap-2 box-border">
                <div
                  aria-hidden
                  className={
                    styles.navButton +
                    ' w-full lg:w-5/6 h-10 lg:h-12 text-xs sm:text-sm	font-semibold	flex justify-center items-center cursor-pointer'
                  }
                  onClick={() => goToProjSub()}
                >
                  Submit Your Project
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  };
